import React from 'react';
import { Grid, Typography } from '@mui/material';
import { getNumberComma } from '../../../utils/numberUtils';

const CostSummary = ({
  chance,
  costsVat,
  totalPurchase,
  totalSales,
  totalSalesIn,
  totalProfit,
  totalProfitIn,
  totalMargin,
  totalMarginIn,
}) => {
  const handleToggleDesc = () => {
        console.log('aaa1');
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
    >
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div" onClick={handleToggleDesc}>
          총 매출액
          
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {chance?.totalSales
            ? getNumberComma(chance.totalSales)
            : getNumberComma(totalSales)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          총 매입액
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {chance?.totalPurchase
            ? getNumberComma(chance.totalPurchase)
            : getNumberComma(totalPurchase)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          총 매출이익
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {chance?.totalProfit
            ? getNumberComma(chance?.totalProfit)
            : getNumberComma(totalProfit)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          이익율
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {chance?.expBenefitRate !== undefined
          ? `${Number(chance?.expBenefitRate).toFixed(2)} %`
          : `${Number(totalMargin).toFixed(2)} %`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CostSummary;
